import { BLUE } from "../../styles/colors";
import Chevron from "../Chevron/Chevron";
import { useState } from "react";
import {
    Container,
    HeaderContainer,
    Title,
    ChevronContainer,
    StepsContainer,
    StepRowContainer,
    StepNumberContainer,
    StepNumber,
    StepNumberBackground,
    StepNumberOuterBackground,
    StepConnectorDown,
    StepConnectorUp,
    StepTextContainer,
    StepText,
    StepDivider
} from "./ExpandableStepList.styles";

export type ExpandableStepListProps = {
    title: string;
    steps: string[];
};

const ExpandableStepList = ({ title, steps }: ExpandableStepListProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    return (
        <Container onClick={() => setIsExpanded(!isExpanded)}>
            <HeaderContainer $isExpanded={isExpanded}>
                <Title>{title}</Title>
                <ChevronContainer>
                    <Chevron direction={isExpanded ? 'up' : 'down'} color={BLUE} strokeWidth={1} />
                </ChevronContainer>
            </HeaderContainer>
            {isExpanded && (
                <StepsContainer>
                    {steps.map((step, index) => (
                        <StepRow
                            key={index}
                            index={index}
                            text={step}
                            isFirst={index === 0}
                            isLast={index === steps.length - 1}
                        />
                    ))}
                </StepsContainer>
            )}
        </Container>
    )
}

const StepRow = ({
    index,
    text,
    isFirst = false,
    isLast = false
}: {
    index: number,
    text: string,
    isFirst?: boolean,
    isLast?: boolean
}) => {
    return (
        <StepRowContainer>
            <StepNumberContainer>
                <StepNumber>{index + 1}</StepNumber>
                <StepNumberBackground />
                <StepNumberOuterBackground />
                {!isLast && <StepConnectorDown />}
                {!isFirst && <StepConnectorUp />}
            </StepNumberContainer>
            <StepTextContainer>
                <StepText>{text}</StepText>
                {!isLast && <StepDivider />}
            </StepTextContainer>
        </StepRowContainer>
    )
}

export default ExpandableStepList
